<template>
  <b-container class="register-page py-5">
    <b-row class="justify-content-center">
      <b-col md="6" lg="5">
        <b-card title="Crear Cuenta" class="shadow">
          <b-form @submit.prevent="handleRegister">
            <b-form-group label="Nombre completo" label-for="name">
              <b-form-input
                id="name"
                v-model="form.name"
                required
                placeholder="Tu nombre completo">
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                required
                placeholder="tu@email.com">
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Teléfono" label-for="phone">
              <b-form-input
                id="phone"
                v-model="form.phone"
                type="tel"
                placeholder="Tu número de teléfono">
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Contraseña" label-for="password">
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="Mínimo 8 caracteres">
              </b-form-input>
            </b-form-group>
            
            <b-form-group label="Confirmar contraseña" label-for="password2">
              <b-form-input
                id="password2"
                v-model="form.password2"
                type="password"
                required
                placeholder="Repite tu contraseña">
              </b-form-input>
            </b-form-group>
            
            <b-form-checkbox v-model="form.terms" class="mb-3">
              Acepto los términos y condiciones
            </b-form-checkbox>
            
            <b-button 
              type="submit" 
              variant="primary" 
              block
              :disabled="loading || !form.terms">
              <b-spinner v-if="loading" small class="mr-2"></b-spinner>
              Crear Cuenta
            </b-button>
          </b-form>
          
          <hr>
          
          <div class="text-center">
            <p>¿Ya tienes una cuenta?</p>
            <b-button variant="outline-primary" :to="{ name: 'Login' }">
              Iniciar Sesión
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'RegisterPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        password: '',
        password2: '',
        terms: false
      },
      loading: false
    }
  },
  methods: {
    async handleRegister() {
      if (this.form.password !== this.form.password2) {
        this.$bvToast.toast('Las contraseñas no coinciden', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      
      if (this.form.password.length < 8) {
        this.$bvToast.toast('La contraseña debe tener al menos 8 caracteres', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      
      this.loading = true
      
      const result = await this.$store.dispatch('register', this.form)
      
      if (result.success) {
        this.$bvToast.toast(result.message || 'Registro exitoso', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
        
        // Redirigir al login
        this.$router.push({ name: 'Login' })
      } else {
        this.$bvToast.toast(result.message || 'Error al registrarse', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      
      this.loading = false
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 60vh;
}
</style>